/*
General global
*/
import './utils/global'
import './components/paragraphSemifinalists'
import './components/paragraphSlatCarousel'
import './components/ParagraphAccordionAcummulation'